let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cqNU4")).then(() => parcelRequire('9c4UU'));